import React, { useState, useEffect } from "react";
import Logo from "./Logo";
import { Button } from "./ui/button";
import { PRICE_LABEL, startCheckout } from "@/lib/checkout";
import { T } from "@/constants/testIds";
import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";

const links = [
  { href: "#casos", label: "Casos" },
  { href: "#timeline", label: "Linha do Tempo" },
  { href: "#mensalao", label: "Mensalão" },
  { href: "#triplex", label: "Triplex" },
  { href: "#fontes", label: "Fontes" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid={T.navLogo} className="shrink-0">
          <Logo className="h-8 w-8" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[12px] tracking-[0.2em] uppercase text-neutral-400 hover:text-red-500 transition-colors font-mono"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={startCheckout}
            aria-label={`Comprar ebook por ${PRICE_LABEL}`}
            data-testid="nav-cart-icon"
            className="relative h-9 w-9 inline-flex items-center justify-center border border-white/15 text-neutral-300 hover:border-red-600 hover:text-red-500 transition-colors rounded-sm"
          >
            <ShoppingBag className="h-4 w-4" />
            <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-red-600 border border-black" />
          </button>
          <Button
            data-testid={T.navBuy}
            onClick={startCheckout}
            className="bg-red-600 hover:bg-red-700 text-white font-mono tracking-wider text-[11px] uppercase rounded-sm px-4 h-9 inline-flex items-center gap-2"
          >
            <ShoppingBag className="h-3.5 w-3.5" />
            Comprar · {PRICE_LABEL}
          </Button>
        </div>
      </div>
    </motion.header>
  );
}
